import { Skeleton, Typography } from '@mui/material';
import { toLocalDateTimeString } from 'common';
import { CfIconButton } from '../../../../cf-ui/buttons/CfIconButton';
import { CfDataGridTableViewDefinitions, CfDataGridValueGetterProps } from '../../../../cf-ui/DataGrid/CfDataGridProps';
import { DiaryGridItem } from './DiaryGrid';

export const createTableViewDefinitions = (
  onRevert?: (id: string) => void
): CfDataGridTableViewDefinitions<DiaryGridItem> => ({
  xs: {
    virtualizedProps: { enabled: true },
    showHeader: true,
    columns: [
      {
        title: 'Action',
        width: '16%',
        value: function column(props: CfDataGridValueGetterProps<DiaryGridItem>) {
          return <Typography variant='responsiveParagraphBold'>{props.item.action}</Typography>;
        },
        loadingPlaceholder: (
          <Skeleton variant='text'>
            <Typography variant='responsiveParagraphBold'>Log Diary</Typography>
          </Skeleton>
        ),
      },
      {
        title: 'Summary',
        width: '50%',
        value: function column(props: CfDataGridValueGetterProps<DiaryGridItem>) {
          return (
            <Typography variant='responsiveParagraph' style={{ whiteSpace: 'pre-line', lineBreak: 'anywhere' }}>
              {props.item.summary}
            </Typography>
          );
        },
        loadingPlaceholder: (
          <Skeleton variant='text'>
            <Typography variant='responsiveParagraph'>Log Diary</Typography>
          </Skeleton>
        ),
      },
      {
        title: 'Changed by',
        width: !onRevert ? '22%' : '12%',
        value: function column(props: CfDataGridValueGetterProps<DiaryGridItem>) {
          return (
            <Typography variant='responsiveParagraph' sx={{ lineBreak: 'anywhere' }}>
              {props.item.changeBy}
            </Typography>
          );
        },
        loadingPlaceholder: (
          <Skeleton variant='text'>
            <Typography variant='responsiveParagraph'>Log Diary</Typography>
          </Skeleton>
        ),
      },
      {
        title: 'Log date',
        width: '12%',
        value: function column(props: CfDataGridValueGetterProps<DiaryGridItem>) {
          return <Typography variant='responsiveParagraph'>{toLocalDateTimeString(props.item.logDate)}</Typography>;
        },
        loadingPlaceholder: (
          <Skeleton variant='text'>
            <Typography variant='responsiveParagraph'>Log Diary</Typography>
          </Skeleton>
        ),
      },
      {
        title: !onRevert ? '' : 'Restore',
        width: !onRevert ? '0%' : '10',
        value: function column(props: CfDataGridValueGetterProps<DiaryGridItem>) {
          return (
            props.item.canRevert &&
            onRevert && (
              <CfIconButton
                iconSize='medium'
                className='fa fa-undo'
                color='primary'
                onClick={() => onRevert(props.item.id)}
              />
            )
          );
        },
        loadingPlaceholder: (
          <Skeleton variant='text'>
            <Typography variant='responsiveParagraph'>Log Diary</Typography>
          </Skeleton>
        ),
      },
    ],
  },
});
